var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.containerClass,attrs:{"aria-live":"polite"}},[_c('span',{class:_vm.iconClass}),_c('span',{staticClass:"p-inline-message-text"},[_vm._t("default",[_vm._v(" ")])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }